export default "__VITE_ASSET__cNLGmzyN__"